import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {Link} from "react-router-dom";
import {PROPERTY_KEY_BRAND_ORIGIN} from "../../Config";
import BrandLink from "./BrandLink";

export default function BrandInfo({product}: { product: ProductInterface }) {
    const normalizeCountryName = (name: string) => {
        return name.toLowerCase().replace(/[^а-яa-z]/g, '');
    }

    const flags: Record<string, string> = {
        [normalizeCountryName('ТАЙВАНЬ (КИТАЙ)')]: 'icon-kit.svg',
        [normalizeCountryName('ТАЙВАНЬ')]: 'icon-kit.svg',
        [normalizeCountryName('КИТАЙ')]: 'icon-kit.svg',
        [normalizeCountryName('Россия')]: 'icon-ros.svg',
    }

    const parseItemText = (text: string) => {
        const match = text.match(/\[%(\d+)%\]/);
        if (match) {
            const code = match[1];
            const cleanText = text.replace(/\[%\d+%\]/, '').trim();
            return { code, text: cleanText };
        }
        return { code: null, text };
    }


    return (<div className="d-flex flex-column prod-pane__right">
        <div className="d-flex flex-column pane-brand prod-pane__brand">
            <div className="d-flex justify-content-between gap-3 pane-brand__head">
                <div className="d-flex flex-column pane-brand__head-body">
                    <div className="d-flex align-items-center pane-brand__text-logo">
                        <p className="fw-bold text-uppercase">{product.brand_name}</p>
                    </div>
                    <BrandLink brandName={product.brand_name} />
                </div>
                <div className="pane-brand__logo">
                    <img className="w-100"
                         src={'https://www.pride.ru/images/logos/' + product.brand_name.toLowerCase() + '.svg'} alt=""/>
                </div>
            </div>
            <div className="d-flex flex-column pane-brand__bot">
                {product.properties?.[PROPERTY_KEY_BRAND_ORIGIN]?.[0] && (
                    <div className="d-flex align-items-center pane-brand__bot-item">
                        {flags[normalizeCountryName(product.properties[PROPERTY_KEY_BRAND_ORIGIN][0])] &&  <img src={'/images/' + flags[normalizeCountryName(product.properties[PROPERTY_KEY_BRAND_ORIGIN][0])]} alt=""/>}
                        <p>{product.properties[PROPERTY_KEY_BRAND_ORIGIN][0]} – родина бренда</p>
                    </div>
                )}
                <div className="d-flex align-items-center pane-brand__bot-item">
                    {flags[normalizeCountryName(product.additional_params?.country || '')] &&  <img src={'/images/' + flags[normalizeCountryName(product.additional_params?.country || '')]} alt=""/>}
                    <p>{product.additional_params?.country} – страна производства</p>
                </div>
            </div>
        </div>
        {product.additional_params?.specification_list_raw?.length &&  <div className="d-flex flex-column prod-pane__right-body">
            <p className="fw-bold text-uppercase">комплектация</p>
            <ul className="d-flex flex-column">
                {product.additional_params.specification_list_raw.map((item, index) => {
                    const {code, text} = parseItemText(item);
                    return (
                        <li key={index}>
                            {text.trim() && <span className="t-orange cicle">●</span>}
                            {code ? (
                                <Link to={`/catalog/item-by-code/${code}`} className="t-orange text-decoration-underline">{text}</Link>
                            ) : (
                                <span>{text}</span>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>}
    </div>)
}